// Masonry Library
// Docs: http://masonry.desandro.com
var Masonry = require('masonry-layout');

module.exports = function() { };
